import * as _ from 'underscore';

import { QueryParameterHelper } from '../helpers/QueryParameterHelper';
import { Module } from '../Module';

export interface IStateHrefAttributes extends ng.IAttributes {
  tbStateHrefConfig: string;
  tbStateHrefParams: string;
  tbStateHrefOpts: string;
}

interface IStateHrefConfig {
  keepSearch: boolean;
  omitParams: string[];
}

Module.instance().directive('tbStateHref', <any[]>[
  '$location',
  '$state',
  ($location: ng.ILocationService, $state: ng.ui.IStateService) => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attributes: IStateHrefAttributes) => {
        let config: IStateHrefConfig = scope.$eval(attributes.tbStateHrefConfig || '') || {};
        const params = scope.$eval(attributes.tbStateHrefParams || '') || null;
        const opts = scope.$eval(attributes.tbStateHrefOpts || '') || null;

        let keepSearch = config.keepSearch;
        let omitParams = config.omitParams || [];
        let state: string;

        const updateHref = () => {
          if (_.isString(state)) {
            let href = $state.href(state, params, opts);
            if (keepSearch) {
              const stateParams = $state.params ? Object.keys($state.params) : [];
              href = QueryParameterHelper.urlWithParams(href, _.omit($location.search(), omitParams.concat(stateParams)));
            }
            attributes.$set('href', href);
          }
        };

        attributes.$observe('tbStateHref', (value: string) => {
          state = value;
          updateHref();
        });

        attributes.$observe('tbStateHrefConfig', (value: string) => {
          config = scope.$eval(value || '') || {};
          keepSearch = config.keepSearch;
          omitParams = config.omitParams || [];
          updateHref();
        });

        if (keepSearch) {
          scope.$on('$locationChangeSuccess', updateHref);
          scope.$on('$stateChangeSuccess', updateHref);
        }
      }
    };
  }
]);
